import { Button, Card } from "react-bootstrap";

import "../RenderIndex/RenderIndex.scss";
import "./IndexSkeloton.scss";

export default function IndexSkeloton() {
  return (
    <>
      <section className="cardInfoContainer">
        <Card className="itemsCard">
          <div src="" alt="" className="itemsCard-skeloton"></div>
          <Card.Body className="itemInfo">
            <Card.Title>
              <div className="skeloton-title"></div>
            </Card.Title>
            <Card.Text>
              <div className="skeloton-description"></div>
            </Card.Text>
            <Card.Text>
              <div className="skeloton-description"></div>
            </Card.Text>
            <div className="skeloton-button"></div>
          </Card.Body>
        </Card>
      </section>
      <section className="cardInfoContainer">
        <Card className="itemsCard">
          <div src="" alt="" className="itemsCard-skeloton"></div>
          <Card.Body className="itemInfo">
            <Card.Title>
              <div className="skeloton-title"></div>
            </Card.Title>
            <Card.Text>
              <div className="skeloton-description"></div>
            </Card.Text>
            <Card.Text>
              <div className="skeloton-description"></div>
            </Card.Text>
            <div className="skeloton-button"></div>
          </Card.Body>
        </Card>
      </section>
      <section className="cardInfoContainer">
        <Card className="itemsCard">
          <div src="" alt="" className="itemsCard-skeloton"></div>
          <Card.Body className="itemInfo">
            <Card.Title>
              <div className="skeloton-title"></div>
            </Card.Title>
            <Card.Text>
              <div className="skeloton-description"></div>
            </Card.Text>
            <Card.Text>
              <div className="skeloton-description"></div>
            </Card.Text>
            <div className="skeloton-button"></div>
          </Card.Body>
        </Card>
      </section>
      <section className="cardInfoContainer">
        <Card className="itemsCard">
          <div src="" alt="" className="itemsCard-skeloton"></div>
          <Card.Body className="itemInfo">
            <Card.Title>
              <div className="skeloton-title"></div>
            </Card.Title>
            <Card.Text>
              <div className="skeloton-description"></div>
            </Card.Text>
            <Card.Text>
              <div className="skeloton-description"></div>
            </Card.Text>
            <div className="skeloton-button"></div>
          </Card.Body>
        </Card>
      </section>
      <section className="cardInfoContainer">
        <Card className="itemsCard">
          <div src="" alt="" className="itemsCard-skeloton"></div>
          <Card.Body className="itemInfo">
            <Card.Title>
              <div className="skeloton-title"></div>
            </Card.Title>
            <Card.Text>
              <div className="skeloton-description"></div>
            </Card.Text>
            <Card.Text>
              <div className="skeloton-description"></div>
            </Card.Text>
            <div className="skeloton-button"></div>
          </Card.Body>
        </Card>
      </section>
      <section className="cardInfoContainer">
        <Card className="itemsCard">
          <div src="" alt="" className="itemsCard-skeloton"></div>
          <Card.Body className="itemInfo">
            <Card.Title>
              <div className="skeloton-title"></div>
            </Card.Title>
            <Card.Text>
              <div className="skeloton-description"></div>
            </Card.Text>
            <Card.Text>
              <div className="skeloton-description"></div>
            </Card.Text>
            <div className="skeloton-button"></div>
          </Card.Body>
        </Card>
      </section>
    </>
  );
}
